/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How We Check Our Work`)
};

const es_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo comprobamos nuestro trabajo`)
};

const de_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wir unsere Arbeit prüfen`)
};

const nl_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe we ons werk controleren`)
};

const fr_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment nous vérifions notre travail`)
};

const it_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come verifichiamo il nostro lavoro`)
};

const pt_br2_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como verificamos nosso trabalho`)
};

const pt_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como verificamos o nosso trabalho`)
};

const ja_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業内容の確認方法`)
};

const zh_about_section_verify = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们如何核实工作`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_section_verify = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_section_verify(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_section_verify", locale)
	if (locale === "en") return en_about_section_verify(inputs)
	if (locale === "es") return es_about_section_verify(inputs)
	if (locale === "de") return de_about_section_verify(inputs)
	if (locale === "nl") return nl_about_section_verify(inputs)
	if (locale === "fr") return fr_about_section_verify(inputs)
	if (locale === "it") return it_about_section_verify(inputs)
	if (locale === "pt-BR") return pt_br2_about_section_verify(inputs)
	if (locale === "pt") return pt_about_section_verify(inputs)
	if (locale === "ja") return ja_about_section_verify(inputs)
	return zh_about_section_verify(inputs)
};